import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

export default class Row extends PureComponent {
    static propTypes = {
        rowChildren: PropTypes.arrayOf(PropTypes.node).isRequired,
    };

    render() {
        return (
            <tr>
                {this.props.rowChildren.map((rowChild, i) =>
                    <td key={i}>{rowChild}</td> // eslint-disable-line react/no-array-index-key
                )}
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/OldEventsTable/Row.js